var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "drive-home",
      on: {
        dragenter: function ($event) {
          $event.preventDefault()
          return _vm.handleDragEnter.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.handleDragLeave.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.handleDrop.apply(null, arguments)
        },
        paste: function ($event) {
          $event.preventDefault()
          return _vm.handlePaste.apply(null, arguments)
        },
        contextmenu: function ($event) {
          $event.preventDefault()
          return _vm.handleContextMenu.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "drive-header" },
        [
          _c(
            "a-breadcrumb",
            [
              _c(
                "a-breadcrumb-item",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.navigateToFolder(null)
                    },
                  },
                },
                [_c("a-icon", { attrs: { type: "home" } })],
                1
              ),
              _vm._v(" "),
              _vm._l(
                _vm.$_.takeRight(
                  _vm.breadcrumbFolders,
                  _vm.breadcrumbFolders.length - 1
                ),
                function (folder, index) {
                  return _vm.breadcrumbFolders.length > 1
                    ? _c("a-breadcrumb-item", { key: folder._id }, [
                        index < _vm.breadcrumbFolders.length - 1
                          ? _c(
                              "a",
                              {
                                attrs: { href: "#" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.navigateToFolder(folder._id)
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(folder.name) +
                                    "\n                "
                                ),
                              ]
                            )
                          : _c("span", [_vm._v(_vm._s(folder.name))]),
                      ])
                    : _vm._e()
                }
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c("h1", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.navigateToFolder(null)
                  },
                },
              },
              [_vm._v("Drive")]
            ),
            _vm._v(" "),
            _vm.breadcrumbFolders.length > 1
              ? _c("span", [
                  _vm.breadcrumbFolders.length > 2
                    ? _c("span", [_vm._v(" > ")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.breadcrumbFolders.length > 2
                    ? _c(
                        "a",
                        {
                          attrs: { href: "#" },
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              return _vm.navigateToFolder(
                                _vm.breadcrumbFolders[
                                  _vm.breadcrumbFolders.length - 2
                                ]._id
                              )
                            },
                          },
                        },
                        [_vm._v("\n                    ...\n                ")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.breadcrumbFolders.length > 1
                    ? _c("span", [
                        _vm._v(
                          "\n                    > " +
                            _vm._s(
                              _vm.breadcrumbFolders[
                                _vm.breadcrumbFolders.length - 1
                              ].name
                            ) +
                            "\n                "
                        ),
                      ])
                    : _vm._e(),
                ])
              : _vm._e(),
          ]),
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "drive-toolbar" }, [
        _c(
          "div",
          { staticClass: "left-actions" },
          [
            _c(
              "SupsisButton",
              {
                attrs: { icon: "add", primary: "" },
                on: { click: _vm.handleNewFolder },
              },
              [_vm._v(_vm._s(_vm.$t("message.newFolder")))]
            ),
            _vm._v(" "),
            _c(
              "SupsisButton",
              {
                attrs: { icon: "upload_file", primary: "" },
                on: { click: _vm.handleNewFile },
              },
              [_vm._v(_vm._s(_vm.$t("message.newFile")))]
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "right-actions" }, [
          _c(
            "div",
            { staticClass: "view-toggle" },
            [
              _vm.selectedFiles.length > 0
                ? _c(
                    "SupsisButton",
                    {
                      attrs: { icon: "select_all", primary: "" },
                      on: { click: _vm.selectAllFiles },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("chatbotv2.selectAll")) +
                          "\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.selectedFiles.length > 0
                ? _c(
                    "SupsisButton",
                    {
                      attrs: { icon: "delete", danger: "" },
                      on: { click: _vm.handleBulkDelete },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.$t("message.deleteSelected")) +
                          " (" +
                          _vm._s(_vm.selectedFiles.length) +
                          ")\n                "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("SupsisButton", {
                attrs: {
                  icon: "grid_view",
                  ghost: _vm.viewMode === "list",
                  primary: _vm.viewMode === "grid",
                },
                on: {
                  click: function ($event) {
                    _vm.viewMode = "grid"
                  },
                },
              }),
              _vm._v(" "),
              _c("SupsisButton", {
                attrs: {
                  icon: "list",
                  ghost: _vm.viewMode === "grid",
                  primary: _vm.viewMode === "list",
                },
                on: {
                  click: function ($event) {
                    _vm.viewMode = "list"
                  },
                },
              }),
            ],
            1
          ),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "toolbar-divider" }),
      _vm._v(" "),
      _vm.isLoading
        ? _c(
            "div",
            { staticClass: "loading-spinner" },
            [_c("a-spin", { attrs: { size: "large" } })],
            1
          )
        : _vm.currentFiles.length > 0 && _vm.viewMode === "grid"
        ? _c("FilesCardView", {
            attrs: {
              files: _vm.currentFiles,
              selectionMode: _vm.isSelectionMode,
              selectedFiles: _vm.selectedFiles,
            },
            on: {
              folderDoubleClick: _vm.handleFolderDoubleClick,
              delete: _vm.handleDelete,
              fileSelect: _vm.handleFileSelection,
            },
          })
        : _vm.currentFiles.length > 0 && _vm.viewMode === "list"
        ? _c("FilesListView", {
            attrs: {
              files: _vm.currentFiles,
              selectionMode: _vm.isSelectionMode,
              selectedFiles: _vm.selectedFiles,
            },
            on: {
              folderDoubleClick: _vm.handleFolderDoubleClick,
              delete: _vm.handleDelete,
              fileSelect: _vm.handleFileSelection,
            },
          })
        : _c(
            "div",
            { staticClass: "empty-folder-placeholder" },
            [
              _c("i", { staticClass: "material-icons" }, [
                _vm._v("folder_open"),
              ]),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("message.noFilesFound")))]),
              _vm._v(" "),
              _c(
                "SupsisButton",
                {
                  attrs: { icon: "upload_file", primary: "" },
                  on: { click: _vm.handleNewFile },
                },
                [
                  _vm._v(
                    "\n            " + _vm._s(_vm.$t("message.uploadFile"))
                  ),
                ]
              ),
            ],
            1
          ),
      _vm._v(" "),
      _vm.showUploadProgress
        ? _c(
            "div",
            { staticClass: "upload-progress" },
            _vm._l(_vm.activeUploads, function (upload) {
              return _c(
                "div",
                { key: upload.id, staticClass: "upload-item" },
                [
                  _c("span", { staticClass: "filename" }, [
                    _vm._v(_vm._s(upload.fileName)),
                  ]),
                  _vm._v(" "),
                  _c("md-progress-bar", {
                    attrs: {
                      "md-mode": "determinate",
                      "md-value": upload.progress,
                    },
                  }),
                ],
                1
              )
            }),
            0
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.showNewFolderModal
        ? _c(
            "Modal2",
            {
              attrs: {
                title: _vm.$t("message.newFolder"),
                description: _vm.$t("message.enterFolderName"),
                okText: _vm.$t("settings.create"),
                cancelText: _vm.$t("message.cancel"),
              },
              on: {
                ok: _vm.createNewFolder,
                cancel: function ($event) {
                  _vm.showNewFolderModal = false
                },
              },
            },
            [
              _c(
                "div",
                { staticClass: "folder-name-input" },
                [
                  _c("a-input", {
                    ref: "folderNameInput",
                    attrs: { placeholder: _vm.$t("message.folderName") },
                    on: {
                      keyup: function ($event) {
                        if (
                          !$event.type.indexOf("key") &&
                          _vm._k(
                            $event.keyCode,
                            "enter",
                            13,
                            $event.key,
                            "Enter"
                          )
                        ) {
                          return null
                        }
                        return _vm.createNewFolder.apply(null, arguments)
                      },
                    },
                    model: {
                      value: _vm.newFolderName,
                      callback: function ($$v) {
                        _vm.newFolderName = $$v
                      },
                      expression: "newFolderName",
                    },
                  }),
                  _vm._v(" "),
                  _vm.folderNameError
                    ? _c("span", { staticClass: "error-text" }, [
                        _vm._v(_vm._s(_vm.folderNameError)),
                      ])
                    : _vm._e(),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.isDragging
        ? _c("div", { staticClass: "drop-overlay" }, [
            _c("div", { staticClass: "drop-target" }, [
              _c("i", { staticClass: "fas fa-cloud-upload-alt" }),
              _vm._v(" "),
              _c("p", [_vm._v(_vm._s(_vm.$t("message.dropFileHere")))]),
            ]),
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.showContextMenu
        ? _c(
            "div",
            { staticClass: "context-menu", style: _vm.contextMenuStyle },
            [
              _c("div", { staticClass: "context-menu-title" }, [
                _vm._v(_vm._s(_vm.$t("message.actions"))),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleNewFile },
                },
                [
                  _c("i", { staticClass: "fas fa-file-upload text-primary" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.uploadFile")) + "\n        "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "context-menu-item",
                  on: { click: _vm.handleNewFolder },
                },
                [
                  _c("i", { staticClass: "fas fa-folder-plus text-success" }),
                  _vm._v(
                    " " + _vm._s(_vm.$t("message.createFolder")) + "\n        "
                  ),
                ]
              ),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }